import type { IconBaseProps } from "./Icon";

export default function ChevronDown({ color, style, ...otherProps }: IconBaseProps) {
  return (
    <svg
      style={{ color: color, ...style }}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...otherProps}
    >
      <path
        d="M6 9L12 15L18 9"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
